/* eslint-disable react/prop-types */
import clsx from 'clsx';

/** How each client portal log action reads to staff (OL-196). */
const ACTION_LABELS = {
  login: 'Signed in',
  login_failed: 'Failed sign-in',
  login_locked: 'Sign-in blocked (locked)',
  logout: 'Signed out',
  password_set: 'Set their password',
  password_reset_requested: 'Asked for a password reset',
  password_changed: 'Changed their password',
  matter_opened: 'Opened the matter',
  file_previewed: 'Opened',
  file_downloaded: 'Downloaded',
  folder_downloaded: 'Downloaded folder',
  access_denied: 'Was refused',
  guest_invited: 'Invited',
  guest_disabled: 'Disabled the guest',
  guest_enabled: 'Enabled the guest',
  share_created: 'Shared',
  share_updated: 'Changed access to',
  share_revoked: 'Revoked access to',
};

const fmtDateTime = (iso) =>
  iso
    ? new Date(iso).toLocaleString(undefined, { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' })
    : '';

/**
 * Rows from the client portal access log. Staff actions name the staff member
 * as the actor; guest actions name the guest.
 */
const PortalAccessLogList = ({ rows, loading, showMatter = false }) => {
  if (loading) {
    return <p className="text-center text-2sm text-gray-600 py-6">Loading…</p>;
  }

  if (!rows.length) {
    return <p className="text-center text-2sm text-gray-500 py-6">No activity yet.</p>;
  }

  return (
    <div className="max-h-[420px] overflow-y-auto">
      <table className="table table-border text-2sm">
        <thead>
          <tr>
            <th>When</th>
            <th>Who</th>
            <th>What</th>
            {showMatter && <th>Matter</th>}
            <th>IP</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <tr key={row.id} className={clsx(row.outcome === 'denied' && 'text-danger')}>
              <td className="whitespace-nowrap">{fmtDateTime(row.created_at)}</td>
              <td className="max-w-[220px] truncate" title={row.actor}>{row.actor}</td>
              <td>
                {ACTION_LABELS[row.action] ?? row.action}
                {row.target && <span className="text-gray-600"> {row.target}</span>}
              </td>
              {showMatter && <td className="max-w-[200px] truncate">{row.matter ?? '—'}</td>}
              <td className="text-gray-500 whitespace-nowrap">{row.ip ?? ''}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export { PortalAccessLogList };
